import React from 'react'
import { Row, Col, Spinner } from 'react-bootstrap'
import RecordPagination from '../../common/pagination'
import { get } from 'lodash'

const PaginatedList = ({
    items = [],
    loading,
    pageSize = 1,
    itemComponent,
    total = 0,
    offset = 0,
    onOffsetChange = () => {},
    noneFoundMessage = 'None were found.',
    containerComponent = Row
}) => {
    const ItemComponent = itemComponent

    const renderItem = (item, key) => {
        return (
            <ItemComponent key={get(item, 'id', key)} item={item}/>
        )
    }

    const renderItems = () => {
        if (loading) {
            return (
                <Col className='text-center'>
                    &nbsp;<Spinner animation="border" size="sm" />&nbsp;
                </Col>
            )
        }

        if (items && items.length) {
            return items.map(renderItem)
        }

        return (
            <Col className='text-muted text-center'>{noneFoundMessage}</Col>
        )
    }

    const ContainerComponent = containerComponent

    return (
        <React.Fragment>
            <ContainerComponent>
                {renderItems()}
            </ContainerComponent>
            <Row style={{ paddingTop: '20px'}}>
                <Col>
                    <RecordPagination
                        offset={offset}
                        limit={pageSize}
                        total={total}
                        setOffset={onOffsetChange}
                    />
                </Col>
            </Row>
        </React.Fragment>
    )
}

export default PaginatedList